import { UTCDate } from '@date-fns/utc';

type PublishedStrapiItem = {
  attributes: {
    publishedAt: string;
  };
};

export function sortStrapiItemsDesc<T extends PublishedStrapiItem>(
  items: T[]
): T[] {
  return [...items].sort(
    (a, b) => getPublishedAtTime(b) - getPublishedAtTime(a)
  );
}

function getPublishedAtTime(item: PublishedStrapiItem) {
  return new UTCDate(item.attributes.publishedAt).getTime();
}
